var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-row", [
    _c(
      "div",
      { staticClass: "col-md-12" },
      [
        _c("card", { staticClass: "stacked-form" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  _vm.doSubmit(1)
                }
              }
            },
            [
              _vm.$route.params.id === undefined
                ? [
                    _vm.$route.params.id === undefined
                      ? _c("fg-input", { attrs: { label: "Supplier" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group input-typeahead",
                              class:
                                _vm.userProfileUuidError !== null
                                  ? "has-error"
                                  : ""
                            },
                            [
                              _c("typeahead", {
                                ref: "userProfileUuidTypeahead",
                                attrs: {
                                  customQueryParamName: "name",
                                  labelFields: ["name"],
                                  placeholder: "Cari Supplier",
                                  urlSearch: _vm.apiUrl.supplier,
                                  "arr-response": "data",
                                  model: _vm.model.supplier
                                }
                              }),
                              _vm._v(" "),
                              _vm.userProfileUuidError !== null
                                ? _c("p", {
                                    staticClass: "error",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.userProfileUuidError
                                      )
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      : _c("fg-input", { attrs: { label: "Supplier" } }, [
                          _c("p", [_vm._v(_vm._s(_vm.model.supplier.name))])
                        ]),
                    _vm._v(" "),
                    _vm.$route.params.id === undefined
                      ? _c(
                          "div",
                          {
                            staticClass: "form-group",
                            class: { "has-error": _vm.errors.first("poDate") }
                          },
                          [
                            _c("label", [_vm._v("Tanggal PO *")]),
                            _vm._v(" "),
                            _c("el-date-picker", {
                              attrs: {
                                placeholder: "Masukkan Tanggal Pemesanan"
                              },
                              model: {
                                value: _vm.fakeModel.poDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.fakeModel, "poDate", $$v)
                                },
                                expression: "fakeModel.poDate"
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.model.poDate,
                                  expression: "model.poDate"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.modelValidations.poDate,
                                  expression: "modelValidations.poDate"
                                }
                              ],
                              attrs: {
                                type: "hidden",
                                name: "poDate",
                                "data-vv-as": "tanggal order"
                              },
                              domProps: { value: _vm.model.poDate },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.model,
                                    "poDate",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm._t("infoBlock"),
                            _vm._v(" "),
                            _vm._t("helpBlock", [
                              _vm.errors.first("poDate")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-danger invalid-feedback",
                                      staticStyle: { display: "block" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("poDate")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ],
                          2
                        )
                      : _c("fg-input", { attrs: { label: "Po Date" } }, [
                          _c("p", [_vm._v(_vm._s(_vm.model.poDate))])
                        ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.lines, function(line, index) {
                return _c(
                  "b-row",
                  { key: index, staticClass: "border ml-0 mr-0 mb-5 mt-3" },
                  [
                    _c("b-col", { attrs: { md: "10 p-2 mt-3" } }, [
                      _vm._v("\n            List Item\n          ")
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { md: "1 p-0 mt-3 text-center" } }, [
                      index >= 1
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-danger",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.removeLine(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-times" })]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { md: "1 p-0 mt-3 text-center" } },
                      [
                        index + 1 === _vm.lines.length
                          ? _c(
                              "b-button",
                              {
                                attrs: { type: "button", variant: "primary" },
                                on: { click: _vm.addLine }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "plus" }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("fg-input", { attrs: { label: "Product" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group input-typeahead",
                              class:
                                _vm.productError !== null ? "has-error" : ""
                            },
                            [
                              _c("typeahead", {
                                ref: "userProfileUuidTypeahead",
                                refInFor: true,
                                attrs: {
                                  customQueryParamName: "name",
                                  labelFields: ["product_name"],
                                  placeholder: "Cari Product",
                                  urlSearch: _vm.apiUrl.productSearch,
                                  "arr-response": "data",
                                  dataLineIndex: index,
                                  model: line.product,
                                  formType: "productSearch"
                                },
                                on: { doCreateCutomer: _vm.getSize }
                              }),
                              _vm._v(" "),
                              _vm.productError !== null
                                ? _c("p", {
                                    staticClass: "error",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.productError)
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    line.productSize.length !== 0
                      ? _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          _vm._l(line.productSize, function(productSize) {
                            return _c(
                              "div",
                              {
                                key: productSize.id,
                                attrs: {
                                  id: "noDataLineIndexContainer",
                                  noDataLineIndex: index
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "my-4" },
                                  _vm._l(productSize.data_color, function(
                                    color
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: color.id,
                                        staticClass:
                                          "custom-control-lg custom-control custom-checkbox",
                                        staticStyle: {
                                          display: "inline-block",
                                          "padding-right": "1rem"
                                        }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: line.selectedColorId,
                                              expression: "line.selectedColorId"
                                            }
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            id:
                                              "checkbox-warna-" +
                                              index +
                                              "-" +
                                              color.color.id,
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            value: color.color.id,
                                            checked: Array.isArray(
                                              line.selectedColorId
                                            )
                                              ? _vm._i(
                                                  line.selectedColorId,
                                                  color.color.id
                                                ) > -1
                                              : line.selectedColorId
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = line.selectedColorId,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = color.color.id,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      line,
                                                      "selectedColorId",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      line,
                                                      "selectedColorId",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  line,
                                                  "selectedColorId",
                                                  $$c
                                                )
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "custom-control-label",
                                            attrs: {
                                              for:
                                                "checkbox-warna-" +
                                                index +
                                                "-" +
                                                color.color.id
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(color.color.name) +
                                                "\n                      "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  })
                                ),
                                _vm._v(" "),
                                _vm._l(line.productSize, function(productSize) {
                                  return _c(
                                    "div",
                                    {
                                      key: productSize.id,
                                      staticClass: "table-responsive"
                                    },
                                    [
                                      _vm._l(productSize.data_product, function(
                                        data_product
                                      ) {
                                        return [
                                          line.selectedColorId.includes(
                                            data_product.color_id
                                          )
                                            ? _c(
                                                "table",
                                                {
                                                  key: data_product.id,
                                                  staticClass:
                                                    "table table-bordered table-striped mt-5",
                                                  staticStyle: {
                                                    "overflow-x":
                                                      "auto !important"
                                                  }
                                                },
                                                [
                                                  _c("thead", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        staticClass:
                                                          "text-center"
                                                      },
                                                      [
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "align-middle"
                                                          },
                                                          [_vm._v("Warna")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "align-middle"
                                                          },
                                                          [_vm._v("Size")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "align-middle"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Stock Saat Ini"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "align-middle"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Stock Dipesan"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "align-middle"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Stock Akhir"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "align-middle"
                                                          },
                                                          [_vm._v("Modal")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "align-middle"
                                                          },
                                                          [_vm._v("Total")]
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "tbody",
                                                    _vm._l(
                                                      data_product.product_size,
                                                      function(
                                                        product_size,
                                                        indx
                                                      ) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key: product_size.id
                                                          },
                                                          [
                                                            indx === 0
                                                              ? [
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticClass:
                                                                        "font-weight-bold text-center align-middle",
                                                                      attrs: {
                                                                        width:
                                                                          "150",
                                                                        rowspan:
                                                                          data_product
                                                                            .product_size
                                                                            .length
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          data_product
                                                                            .color
                                                                            .name
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-center",
                                                                attrs: {
                                                                  width: "150"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    product_size
                                                                      .size.name
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-center",
                                                                attrs: {
                                                                  width: "150"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    product_size.stock
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-center",
                                                                attrs: {
                                                                  width: "150"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    attrs: {
                                                                      type:
                                                                        "number",
                                                                      placeholder:
                                                                        "Masukkan jumlah pesanan"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        product_size.ordered,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          product_size,
                                                                          "ordered",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "product_size.ordered"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-center",
                                                                attrs: {
                                                                  width: "150"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    product_size.stock +
                                                                      parseInt(
                                                                        product_size.ordered
                                                                      )
                                                                  ) + " "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                attrs: {
                                                                  width: "150"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.formatNumber(
                                                                      product_size.capital_price
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                attrs: {
                                                                  width: "150"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.formatNumber(
                                                                      product_size.ordered ===
                                                                      0
                                                                        ? product_size.capital_price *
                                                                          0
                                                                        : product_size.capital_price *
                                                                          parseInt(
                                                                            product_size.ordered
                                                                          )
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      }
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                })
                              ],
                              2
                            )
                          })
                        )
                      : _vm._e()
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.$route.params.id === undefined
                ? _c(
                    "div",
                    { staticClass: "bubble-info" },
                    [
                      _c("save-data-button", {
                        attrs: {
                          disabled: _vm.saveButtonData.isLoading,
                          "is-create": _vm.$route.params.id === undefined,
                          state:
                            _vm.saveButtonData.isLoading &&
                            _vm.saveButtonData.state === 1
                              ? 2
                              : _vm.saveButtonData.state,
                          "is-loading": _vm.saveButtonData.isLoading
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-3",
                          attrs: { type: "button", variant: "secondary" },
                          on: {
                            click: function($event) {
                              _vm.doSubmit(0)
                            }
                          }
                        },
                        [_vm._v("\n            Simpan ke draft\n          ")]
                      )
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "bubble-info" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-3",
                          attrs: { type: "button", variant: "secondary" },
                          on: {
                            click: function($event) {
                              _vm.doSubmit(0)
                            }
                          }
                        },
                        [_vm._v("\n            Simpan\n          ")]
                      )
                    ],
                    1
                  ),
              _vm._v(" "),
              _c("cancel-button", { staticClass: "mr-3" })
            ],
            2
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-549044e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-549044e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Pos/Form.vue
// module id = 0x6R
// module chunks = 4